import {
    AbstractPmsApiService
} from "./index";

import {
    User
} from '../models';


export class PropertyUserPmsApiService extends AbstractPmsApiService {

    get urlPattern() {
        return '/property/:propertyId/user(/:userId)(/:se)';
    }

    get(params = {}, property) {

        const ignoreLB = params.hasOwnProperty('searchValue');

        const url = this.url({
            propertyId: property.id
        });

        return this.http.get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(
                this.getPaginationCollector()
            )
            .catch(this.getErrorHandler());
    }

    create(model, property) {
        const url = this.url({
            propertyId: property.id
        });

        return this.http.post(url, model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    update(user, property) {
        const url = this.url({
            propertyId: property.id,
            userId: user.id,
        });
        return this.http.put(url, user, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());

    }

    newModel(attributes) {

        return new User(attributes);
    }


    delete(user) {
        const url = this.url({
            propertyId: user.property.id,
            userId: user.id,
        });

       return this.http.delete(url, {
                headers: this.authHeaders
            }).then(this.getStatusExtractor())
            .catch(this.getErrorHandler())
    }

    saveOrFail(user, property){
       const userId = angular.isDefined(user.id)? '/'+ user.id: '';

        const url = `${process.env.API_URL}/property/${property.id}/save-user${userId}`;

        return this.http.post(url, user,{
            headers: this.authHeaders
        }).then(this.getModeler())
        .catch(this.getErrorHandler());

    }

    reassignRole(user, property, oldUserId){

         oldUserId = angular.isDefined(oldUserId)? '/'+ oldUserId : '';

         const url = `${process.env.API_URL}/property/${property.id}/reassign_user/${user.id}${oldUserId}`;
 
         return this.http.post(url, user,{
             headers: this.authHeaders
         }).then(this.getModeler())
         .catch(this.getErrorHandler());
 
     }

     show(user, property){
        const url = this.url({
            propertyId: property,
            userId: user
        });

       return this.http.get(url, {
            headers: this.authHeaders
        })
        .then(this.getModeler())
        .catch(this.getErrorHandler());
     }

    emailRequest(user, property) {

        const url = this.url({
            propertyId: property.id,
            userId: user.id,
            se: 'send-email'
        });

        return this.http.post(url, user.toObject(), {
            headers: this.authHeaders
        }).catch(
            (send_fail) => console.warn(send_fail)
        );
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/property-user.service.js